import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";
export default {
  init() {

    if($('.block-features').length){
    gsap.registerPlugin(ScrollTrigger); 
    
    var 
      blockName = '.block-features',
      featuresBlock = '.features-gsap-container',
      featuresIntro = '.features-intro',
      featureImg = '.feature-image',
      featureImgMobile = '.feature-image-mobile',
      features = '.features',
      viewAll = '.view-all-btn',
      windowW = $(window).width(),
      featuresTl = gsap.timeline({
        scrollTrigger : {
          trigger : blockName,
          start : '-100px center',
          once : true,
        }
      });
    
    gsap.set(featuresIntro, {autoAlpha: 0, y:100});
    gsap.set(featureImg, {autoAlpha: 0});
    gsap.set(featureImgMobile, {autoAlpha: 0, y:100});
    gsap.set(features, {autoAlpha: 0, y:100});
    gsap.set(viewAll, {autoAlpha: 0});
    
    if(windowW >= 1000 ){

      gsap.to(featureImg, {
        scrollTrigger : {
          trigger : blockName,
          start : '500px center',
          end : 'bottom bottom',
          pin : featureImg
        }, 
        autoAlpha: 1
      })
    } else {
      gsap.to(featureImgMobile, {
        scrollTrigger : {
          trigger : featuresIntro,
          start : '-400px top'
        }, 
        autoAlpha: 1, y:0
      })
    }

    featuresTl
      .to(featuresIntro, {autoAlpha:1, y:0})
      .to(features, {autoAlpha:1, y:0, stagger: .5})
      .to(viewAll, {autoAlpha: 1});
    }
  },
  finalize() {}
}